/* Vedic Shop Journal v2: progress bar, jump links, inline product placement, sticky bar. No dependencies. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var body = document.querySelector('.vs-body.rte');

    /* PM 22 Oct: the jump list starts collapsed on mobile so the article opens first; always open on desktop */
    var tocDetails = document.querySelector('.vs-toc details');
    if (tocDetails) { tocDetails.open = window.innerWidth >= 990; }

    /* PM 22 Oct: wide tables scroll inside their own box instead of widening the page; 96px minimum per column keeps words whole */
    if (body) {
      if (body.parentNode) { body.parentNode.style.minWidth = '0'; }
      body.querySelectorAll('table').forEach(function (t) {
        if (t.parentNode.classList && t.parentNode.classList.contains('vs-tablewrap')) return;
        var w = document.createElement('div'); w.className = 'vs-tablewrap';
        t.parentNode.insertBefore(w, t); w.appendChild(t);
        if (t.rows.length) { t.style.minWidth = (t.rows[0].cells.length * 96) + 'px'; }
      });
    }

    /* reading progress */
    var bar = document.querySelector('.vs-progress span');
    if (bar && body) {
      var update = function () {
        var r = body.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var done = Math.min(Math.max(-r.top, 0), Math.max(total, 1));
        bar.style.width = (total > 0 ? (done / total) * 100 : 100) + '%';
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    /* jump links from H2s */
    var toc = document.querySelector('[data-vs-toc]');
    if (toc && body) {
      var heads = body.querySelectorAll('h2');
      if (heads.length < 2) { toc.closest('.vs-toc') && (toc.closest('.vs-toc').style.display = 'none'); }
      else {
        var ol = document.createElement('ol');
        heads.forEach(function (h, i) {
          if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9ऀ-ॿ]+/g, '-').replace(/(^-|-$)/g, '');
          var li = document.createElement('li'); var a = document.createElement('a');
          a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li);
        });
        toc.appendChild(ol);
        var count = toc.closest('.vs-toc') && toc.closest('.vs-toc').querySelector('[data-vs-toc-count]');
        if (count) count.textContent = heads.length + ' sections';
        if ('IntersectionObserver' in window) {
          var items = ol.querySelectorAll('li');
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                var idx = Array.prototype.indexOf.call(heads, e.target);
                items.forEach(function (li, j) { li.classList.toggle('is-active', j === idx); });
              }
            });
          }, { rootMargin: '0px 0px -70% 0px' });
          heads.forEach(function (h) { io.observe(h); });
        }
      }
    }

    /* inline product module after the second H2 (falls back to end of body) */
    var mod = document.querySelector('[data-vs-product-module]');
    if (mod && body) {
      var h2s = body.querySelectorAll('h2');
      var anchor = h2s.length >= 3 ? h2s[2] : null;
      mod.hidden = false;
      if (anchor) anchor.parentNode.insertBefore(mod, anchor); else body.appendChild(mod);
    }

    /* sticky bar shows once the reader is past the hero; PM 22 Oct: hides again once the footer is on screen so it never covers footer text */
    var sticky = document.querySelector('.vs-sticky');
    if (sticky) {
      var foot = document.querySelector('footer, .footer');
      var onScroll = function () {
        var nearFoot = foot && foot.getBoundingClientRect().top < window.innerHeight - 40;
        sticky.classList.toggle('is-on', window.scrollY > 600 && !nearFoot);
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  });
})();
